import React from 'react';
import { Route } from 'react-router-dom';
import { IonReactRouter } from '@ionic/react-router';
import { IonApp } from "@ionic/react";
import App from './routes/App';

function RouterConfig() {
  return (
    <IonApp>
      <IonReactRouter>
        <Route path="/" component={App}/>
      </IonReactRouter>
    </IonApp>
  );
}

export default RouterConfig;
